import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import css from '../../css/sidebar/friendList.module.scss';
import sidebarCss from '../../css/sidebar/sidebar.module.scss';
import { ChatGroup } from '../../model/chatGroup';
import { Friend } from '../../model/friend';
import { selectChatGroup, selectGroup } from '../../slice/chatGroupSlice';
import { selectVoiceCall } from '../../slice/voiceCallSlice';

export const FriendList: React.FC<{ friend: Friend; friendGroup: ChatGroup }> = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { selectedChatGroup } = useSelector(selectChatGroup);
    const { group: joinedGroup } = useSelector(selectVoiceCall);

    const onCallUsersCount = props.friendGroup.chatRooms.reduce((current, r) => r.members.length + current, 0);
    const nameStyle =
        selectedChatGroup?.id === props.friendGroup.id ? { color: '#faf8f7', backgroundColor: '#403e3d' } : {};

    return (
        <div className={css.main} style={nameStyle}>
            <img src={props.friend.icon} alt="" />
            <div
                className={css.name}
                onClick={() => {
                    dispatch(selectGroup(props.friendGroup.id));
                    history.push(`/groups/${props.friendGroup.id}`);
                }}
            >
                <p>{props.friend.name}</p>
            </div>
            {onCallUsersCount > 0 && (
                <>
                    {joinedGroup?.id === props.friendGroup.id ? (
                        <span style={{ backgroundColor: '#f14d38' }} className={sidebarCss.mark}>
                            通話中
                        </span>
                    ) : (
                        <span className={sidebarCss.mark} style={{ backgroundColor: '#48d040' }}>
                            {onCallUsersCount}人
                        </span>
                    )}
                </>
            )}
        </div>
    );
};
